import React, { useState } from "react";

const BASE_MINUTES = Array.from({ length: 12 }, (_, i) => i * 5);

// Controlled by App so the initial value can match the server-rendered shell.
export default function TimePicker({ hour, minute, onTimeChange, showNow }) {
    // "Maintenant" can select a minute that isn't a multiple of 5; keep it selectable.
    const [extraMinute, setExtraMinute] = useState(null);

    const minutes = extraMinute === null || BASE_MINUTES.includes(extraMinute)
        ? BASE_MINUTES
        : [...BASE_MINUTES, extraMinute].sort((a, b) => a - b);

    const handleHourChange = (event) => onTimeChange(event.target.value, minute);
    const handleMinuteChange = (event) => onTimeChange(hour, event.target.value);

    const setNowTime = () => {
        const now = new Date();
        const currentHour = now.getHours();
        const currentMinute = now.getMinutes();
        setExtraMinute(currentMinute);
        onTimeChange(currentHour.toString(), currentMinute.toString());
    };

    return (
        <>
            <div className="flex gap-2 sm:gap-4 items-end flex-wrap">
                <div>

                    <label htmlFor="hour" id="hourLabel" className="">Heure</label>
                    <select
                        id="hour"
                        className="input select !w-20 sm:!w-24 !font-mono"
                        onChange={handleHourChange}
                        value={hour}
                        aria-labelledby="hourLabel"
                        aria-required="true"
                        aria-invalid={hour === '' ? 'true' : 'false'}
                    >
                        <option value="">--</option>
                        {Array.from({ length: 24 }, (_, i) => (
                            <option key={i} value={i.toString()}>{i}</option>
                        ))}
                    </select>
                </div>
                <div>
                    <label htmlFor="minute" id="minuteLabel" className="label">Minutes</label>
                    <select
                        id="minute"
                        className="input select !w-20 sm:!w-24 !font-mono"
                        onChange={handleMinuteChange}
                        value={minute}
                        aria-labelledby="minuteLabel"
                        aria-required="true"
                        aria-invalid={minute === '' ? 'true' : 'false'}
                    >
                        <option value="">--</option>
                        {minutes.map((min) => (
                            <option key={min} value={min.toString()}>{String(min).padStart(2, '0')}</option>
                        ))}
                    </select>
                </div>

                <div className="">
                    {showNow && (
                        <button className="flex items-center gap-2 px-3 h-[42px] rounded-lg bg-logob-700 text-white hover:bg-logob-600 focus:outline-none focus:ring-2 focus:ring-slate-300" onClick={setNowTime}>
                            <svg className="hidden sm:block" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="18" height="18" color="#fff" fill="none">
                                <path d="M18.952 8.60657L21.4622 8.45376C19.6629 3.70477 14.497 0.999914 9.4604 2.34474C4.09599 3.77711 0.909631 9.26107 2.34347 14.5935C3.77731 19.926 9.28839 23.0876 14.6528 21.6553C18.6358 20.5917 21.4181 17.2946 22 13.4844" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                                <path d="M12 8V12L14 14" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                            </svg>
                            <span className="text-xs sm:text-sm font-bold">Maintenant</span>

                        </button>
                    )}
                </div>
            </div>
        </>
    );
}
